<template>
  <van-popup v-model="show" closeable get-container="body">
    <div class="pay-confirm">
      <div class="pay-confirm-title">支付</div>
      <div class="pay-confirm-content">
        <div class="pay-confirm-content-text">需要支付 MyLink 點券</div>
        <div class="pay-confirm-content-price">{{ price }}</div>
      </div>
      <div class="pay-confirm-tip">剩餘點券：{{ remain }}</div>
      <div class="pay-confirm-btns">
        <div class="pay-confirm-btns-cancel">
          <div class="tip">多買多送</div>
          <div class="btn" @click="handleRecharge">充值點券</div>
        </div>
        <div class="pay-confirm-btns-submit">
          <div></div>
          <div class="btn" @click="handleSubmit">確認支付</div>
        </div>
      </div>
    </div>
  </van-popup>

</template>


<script>
import { getCouponTotal } from '@/js/axios'
import { Base64 } from 'js-base64';



export default {
  emits: ['close', 'submit'],
  data () {
    return {
      show: false,
      remain: 0,
      price: 0,
      rechargeLink: ''
    }
  },
  methods: {
    async open ({ price }) {
      this.price = price;
      this.getUserData();
      this.show = true;
    },
    close () {
      this.show = false;
      this.$emit('close');
      this.remain = 0;
      this.price = 0;
      this.rechargeLink = '';
    },
    async getUserData () {
      const res = await getCouponTotal();
      if (res.code === 200) {
        const data = JSON.parse(Base64.decode(res.data))

        this.remain = data.coupon_total;
        this.rechargeLink = data.recharge_link?.replace('openhkhshlogin://', "");
      }
    },
    handleRecharge () {
      window.open(this.rechargeLink, '_blank');
    },
    handleSubmit () {
      this.$emit('submit');
      this.close();
    }
  }

}

</script>

<style lang="scss" scoped>
.pay-confirm {
  position: relative;
  width: 90vw;
  background-color: #fff;
  padding: .32rem;

  >div {
    position: relative;
    width: 100%;
  }

  &-title {
    font-size: .48rem;
    color: #000;
    text-align: center;
    margin-bottom: .64rem;
  }

  &-content {
    position: relative;
    border-radius: .12rem;
    background-color: #eee;
    color: #5c5c5c;
    font-size: .24rem;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 2rem;

    >div {
      position: relative;
      height: .64rem;
      display: flex;
      align-items: flex-end;
      overflow: hidden;
    }

    &-price {
      margin-left: .24rem;
      font-size: .64rem;
      color: #723aff;
      font-weight: bold;
      line-height: .64rem;

      &::after {
        content: "";
        width: .64rem;
        height: .32rem;
        margin-left: .24rem;
        background-image: url(../../assets/images/mylink_icon.png);
        background-size: 100%;
        background-repeat: no-repeat;
        background-position: center;
      }
    }


  }

  &-tip {
    padding: .24rem;
    font-size: .32rem;
    color: #000;
    text-align: center;
  }

  &-btns {
    display: grid;
    grid-template-columns: repeat(2, 50%);
    grid-template-rows: 1fr;

    >div {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      flex-direction: column;

      .tip {
        color: #fff;
        font-size: .24rem;
        padding: .08rem .24rem;
        border-radius: .32rem;
        border-bottom-right-radius: 0;
        background-image: linear-gradient(to right, #e2b66a, #f8b506);
        margin-bottom: .24rem;
      }

      .btn {
        font-size: .3rem;
        padding: .2rem .56rem;
        border-radius: 2rem;
      }
    }

    &-cancel {
      .btn {
        border: .02rem solid #8b5cff;
        color: #8b5cff;
      }
    }

    &-submit {
      .btn {
        background-color: #723aff;
        color: #fff;
      }
    }
  }
}
</style>